import React from 'react';

const sentimentMap = {
  neutral: {
    textColor: '#616161',
    backgroundColor: '#EEEEEE',
    text: 'Neutral',
  },
  negative: {
    textColor: '#DC2626',
    backgroundColor: '#FEF2F2',
    text: 'Negative',
  },
  positive: {
    textColor: '#15803D',
    backgroundColor: '#F0FDF4',
    text: 'Purchase Intent',
  },
};

const CommentSentimentTag = ({ sentiment, comments, type }) => {
  const sentimentConfig = sentimentMap[sentiment];

  if (!sentimentConfig) {
    if (type === 'story') {
      return <div className="comment-sentiment-calculating">Not Applicable</div>;
    }

    return (
      <div className="comment-sentiment-calculating">
        {comments !== null && comments > 0 ? 'Calculating' : 'No Comments Yet'}
      </div>
    );
  }

  return (
    <div
      style={{
        color: sentimentConfig.textColor,
      }}
      className="comment-sentiment-tag-container">
      {sentimentConfig.text}
    </div>
  );
};

export default CommentSentimentTag;
